
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { CalendarProvider } from "@/types/calendar";

interface CalendarProviderDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  availableProviders: CalendarProvider[];
  onConnectCalendar: (provider: CalendarProvider) => void;
}

const CalendarProviderDialog = ({ 
  open, 
  onOpenChange, 
  availableProviders, 
  onConnectCalendar 
}: CalendarProviderDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Choose Calendar Provider</DialogTitle>
          <DialogDescription>
            Select which calendar service you want to connect with your Sidekick.
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
          {availableProviders.includes('google') && (
            <Button 
              className="flex gap-2 items-center justify-center" 
              onClick={() => onConnectCalendar('google')}
            >
              <Calendar className="h-4 w-4" />
              Connect Google Calendar
            </Button>
          )}
          {availableProviders.includes('outlook') && (
            <Button 
              variant="outline"
              className="flex gap-2 items-center justify-center" 
              onClick={() => onConnectCalendar('outlook')}
            >
              <Calendar className="h-4 w-4" />
              Connect Outlook Calendar
            </Button>
          )}
          {availableProviders.length === 0 && (
            <p className="text-center text-gray-500">
              You've already connected all available calendar providers.
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CalendarProviderDialog;
